import { format } from 'date-fns';
import React from 'react';
import SelectFieldDate from '../SelectFieldDate';
import { ReactComponent as PlusCircleIcon } from 'icons/plus-icon-circle-blue.svg';
import { ReactComponent as DeleteRoundedIcon } from 'icons/delete-rounded-icon.svg';

const SelectUnavailableDateInput = ({
  data,
  handleSelectUnavailableDate,
  handleAddRangeDate,
  handleRemoveRangeDate,
}) => {
  const renderSelectedDatesValue = (dates) => {
    const fromDate = dates?.from;
    const toDate = dates?.to;

    if (!fromDate || !toDate) return '';

    const formattedFromDate = format(fromDate, 'd MMMM yyyy');
    const formattedToDate = format(toDate, 'd MMMM yyyy');

    return `${formattedFromDate} - ${formattedToDate}`;
  };

  const getDisabledDates = (id) =>
    [...data].filter((date) => date.id !== id && date.from && date.to).map(({ from, to }) => ({ from, to }));

  return (
    <div className="select-unavailable-date">
      <p className="select-field-date__label">Tanggal Unavailable</p>

      <div className="select-unavailable-date__wrapper">
        {data.map((item, index) => (
          <div key={item.id} className="select-unavailable-date__input-wrapper">
            <SelectFieldDate
              name={`unavailable-date-${index}`}
              mode="range"
              placeholder="Pilih Tanggal"
              defaultMonth={item?.from ?? new Date()}
              handleDaySelect={(dates) => handleSelectUnavailableDate(dates, item.id)}
              value={renderSelectedDatesValue(item)}
              htmlFor={`unavailable-date-${index}`}
              selectedDay={item}
              disabledDates={getDisabledDates(item.id)}
            />
            <div className="buttons">
              {index === 0 && data.length < 5 ? (
                <button
                  type="button"
                  className="buttons__icon"
                  aria-label="Tambah rentang tanggal unavailable"
                  onClick={handleAddRangeDate}
                >
                  <PlusCircleIcon width={24} height={24} />
                </button>
              ) : (
                <button
                  type="button"
                  className="buttons__icon"
                  aria-label="Hapus rentang tanggal unavailable"
                  onClick={() => handleRemoveRangeDate(item.id)}
                >
                  <DeleteRoundedIcon width={24} height={24} />
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectUnavailableDateInput;
